export default{
    bill: {
        index: 'bill-index',
    }
}